module.exports = __webpack_public_path__ + "img/recurring.e155ba8e.svg";